/*
Don't change this file manually.
It is autogenerated by @plone/registry.
Instead, change the "addons" registration in the app.
*/

const projectConfigLoader = require('@root/config');
import plonevoltoSlate from '@plone/volto-slate';
import kitconceptvoltoDsgvoBanner from '@kitconcept/volto-dsgvo-banner';
import kitconceptvoltoSolr from '@kitconcept/volto-solr';
import voltoZeelandia from 'volto-zeelandia';

const addonsInfo = [{"name":"@plone/volto-slate","version":"18.7.1","isPublishedPackage":true,"isRegisteredAddon":false,"modulePath":"/app/core/packages/volto-slate/src","packageJson":"/app/core/packages/volto-slate/package.json","basePath":"/app/core/packages/volto-slate","tsConfigPaths":null,"addons":[]},{"name":"@kitconcept/volto-dsgvo-banner","version":"2.3.0","isPublishedPackage":true,"isRegisteredAddon":true,"modulePath":"/app/node_modules/.pnpm/@kitconcept+volto-dsgvo-banner@2.3.0/node_modules/@kitconcept/volto-dsgvo-banner/src","packageJson":"/app/node_modules/.pnpm/@kitconcept+volto-dsgvo-banner@2.3.0/node_modules/@kitconcept/volto-dsgvo-banner/package.json","basePath":"/app/node_modules/.pnpm/@kitconcept+volto-dsgvo-banner@2.3.0/node_modules/@kitconcept/volto-dsgvo-banner","tsConfigPaths":null,"addons":[]},{"name":"@kitconcept/volto-solr","version":"1.0.0-alpha.4","isPublishedPackage":true,"isRegisteredAddon":true,"modulePath":"/app/packages/volto-solr/src","packageJson":"/app/packages/volto-solr/package.json","basePath":"/app/packages/volto-solr","tsConfigPaths":null,"addons":[]},{"name":"volto-zeelandia","version":"1.0.0-alpha.0","isPublishedPackage":true,"isRegisteredAddon":true,"modulePath":"/app/packages/volto-zeelandia/src","packageJson":"/app/packages/volto-zeelandia/package.json","basePath":"/app/packages/volto-zeelandia","tsConfigPaths":[null,{"@plone/volto/*":["../../core/packages/volto/src/*"],"volto-zeelandia/*":["./src/*"]}],"addons":["@kitconcept/volto-dsgvo-banner","@kitconcept/volto-solr"]}];
export { addonsInfo };

const safeWrapper = (func) => (config) => {
  const res = func(config);
  if (typeof res === 'undefined') {
    throw new Error("Configuration function doesn't return config");
  }
  return res;
}


const projectConfig = (config) => {
  return projectConfigLoader && typeof projectConfigLoader.default === "function" ? projectConfigLoader.default(config) : config;
}

const load = (config) => {
  const addonLoaders = [plonevoltoSlate, kitconceptvoltoDsgvoBanner, kitconceptvoltoSolr, voltoZeelandia];
  if(!addonLoaders.every((el) => typeof el === "function")) {
    throw new TypeError(
      'Each addon has to provide a function applying its configuration to the projects configuration.',
    );
  }
  return projectConfig(addonLoaders.reduce((acc, apply) => safeWrapper(apply)(acc), config));
};
export default load;
